import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { Chip, Tooltip } from '@material-tailwind/react';

const RefundChip = ({ variant = undefined, color, value, tooltipHeader = null, tooltipContent = null }: any) => {
	const tooltipExists = tooltipHeader || tooltipContent;

	if (!tooltipExists) {
		return <Chip size="lg" variant={variant} value={value} color={color} />;
	}

	return (
		<Tooltip
			content={
				<div className="flex flex-col max-w-xs">
					{tooltipHeader && <div className="font-bold">{tooltipHeader}</div>}
					{tooltipContent && <div className="italic flex">{tooltipContent}</div>}
				</div>
			}
			placement="right"
		>
			<Chip
				size="lg"
				variant={variant}
				value={value}
				color={color}
				icon={
					tooltipHeader ? (
						<InformationCircleIcon className={`h-6 w-6 text-${variant === 'ghost' ? color : 'white'}`} />
					) : null
				}
			/>
		</Tooltip>
	);
};

export default RefundChip;
